import { FormControl, Select, MenuItem } from '@material-ui/core'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { lang } from '../../utils/lang'

const CustomForm = styled(FormControl)`
  width: 100%;
`
const CustomLabel = styled.label`
  font-size: 1rem;
  font-weight: 700;
  padding-bottom: 0.15rem;
  margin-top: 0.4rem;
`
const CustomSelect = styled(Select)`
  color: ${(props) => props.theme.colors.white};
  background-color: ${(props) => props.theme.colors.midnightBlue};
  margin-bottom: 5px;
  text-transform: uppercase;
  font-size: ${(props) => (props.lang === 'en' ? '0.8rem' : '1rem')};
  .MuiOutlinedInput-input {
    padding: ${(props) => (props.lang === 'en' ? '6px 10px' : '4px 10px')};
    margin-right: ${(props) => (props.lang === 'en' ? '1rem' : 0)};
    margin-left: ${(props) => (props.lang === 'en' ? 0 : '1rem')};
  }
  .MuiSelect-icon {
    color: white;
  }
  .MuiSelect-iconOutlined {
    right: ${(props) => (props.lang === 'en' ? '7px' : 'unset')};
    left: ${(props) => (props.lang === 'en' ? 'unset' : '7px')};
  }
`
//set other classes in overrides

//https://mui-treasury.com/styles/select/
// moves the menu below the select input
const menuProps = {
  // classes: {
  //   paper: minimalSelectClasses.paper,
  //   list: minimalSelectClasses.list
  // },
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left'
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left'
  },
  getContentAnchorEl: null
}

const Filter = ({
  handleChange,
  selections,
  fieldname,
  fieldnameFa,
  options,
  displayOptions,
  dir,
  ui
}) => {
  let optionsArray
  if (options) {
    //sort them by sort_order
    optionsArray = Object.keys(options).map((key) => ({
      id: key,
      value: options[key]
    }))
  }
  let displayOptionsArray
  if (displayOptions) {
    displayOptionsArray = Object.keys(displayOptions).map((key) => ({
      id: key,
      value: displayOptions[key]
    }))
  }

  const sortedOptions = optionsArray?.sort(
    (a, b) => a.value.sort_order - b.value.sort_order
  )
  const faSortedOptions = displayOptionsArray?.sort(
    (a, b) => a.value.sort_order - b.value.sort_order
  )

  const getEnglishValue = (id) => {
    //iterate through optionsArray (or sortedOptions) to find same id and then get title
    const item = sortedOptions?.find((item) => item.id === id)
    if (item) return item.value.title
  }

  //note: vocabs in diff languages have different sort orders
  return (
    <>
      {(ui === 'en' && options) || (ui === 'fa' && displayOptions) ? (
        <CustomForm variant="outlined">
          <CustomLabel htmlFor={fieldname} dir={dir}>
            {ui === 'en' ? fieldname : fieldnameFa}
          </CustomLabel>
          <CustomSelect
            value={selections[fieldname]} // fieldname must be in en in order to reference correct state property
            onChange={(e) => handleChange(e)}
            id={fieldname}
            name={fieldname}
            MenuProps={menuProps}
            IconComponent={ExpandMoreIcon}
            lang={ui} //for styling
            dir={dir}
          >
            <MenuItem value="ALL" dir={dir}>
              {lang[ui].All}
            </MenuItem>
            {(ui === 'en' ? sortedOptions : faSortedOptions).map(
              ({ id, value }) => {
                return (
                  <MenuItem
                    key={id}
                    value={ui === 'en' ? value.title : getEnglishValue(id)} //--> this has to stay in en. if in fa, find title in en
                    className={
                      value.depth > 0
                        ? ui === 'en'
                          ? 'sub-item-en'
                          : 'sub-item-fa'
                        : null
                    }
                    dir={dir}
                  >
                    {value.title}
                  </MenuItem>
                )
              }
            )}
          </CustomSelect>
        </CustomForm>
      ) : null}
    </>
  )
}
export default Filter

Filter.propTypes = {
  handleChange: PropTypes.func,
  selections: PropTypes.object,
  fieldname: PropTypes.string,
  fieldnameFa: PropTypes.string,
  options: PropTypes.object,
  displayOptions: PropTypes.object,
  dir: PropTypes.string,
  ui: PropTypes.string
}
